var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto"},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-actions',[_c('v-btn',{on:{"click":_vm.onCancel}},[_vm._v(_vm._s(_vm.$t("global.action.cancel")))]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.onConfirm}},[_vm._v(_vm._s(_vm.$t("global.action.yes")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }